export const permissions = [
	{ value: "user.view", title: "ดูผู้ใช้งาน", header: "ผู้ใช้งาน" }, //✅
	{ value: "user.create", title: "สร้างผู้ใช้งาน", header: "ผู้ใช้งาน" },
	{ value: "user.update", title: "แก้ไขผู้ใช้งาน", header: "ผู้ใช้งาน" },
	{ value: "user.delete", title: "ลบผู้ใช้งาน", header: "ผู้ใช้งาน" },
	{ value: "userGroup.view", title: "ดูสิทธิผู้ใช้งาน", header: "สิทธิผู้ใช้งาน" }, //✅
	{ value: "userGroup.create", title: "สร้างสิทธิผู้ใช้งาน", header: "สิทธิผู้ใช้งาน" },
	{ value: "userGroup.update", title: "แก้ไขสิทธิผู้ใช้งาน", header: "สิทธิผู้ใช้งาน" },
	{ value: "userGroup.delete", title: "ลบสิทธิผู้ใช้งาน", header: "สิทธิผู้ใช้งาน" },
	{ value: "budget.view", title: "ดูงบประมาณ", header: "งบประมาณ" },
	{ value: "budget.create", title: "สร้างงบประมาณ", header: "งบประมาณ" },
	{ value: "budget.update", title: "แก้ไขงบประมาณ", header: "งบประมาณ" },
	{ value: "budget.delete", title: "ลบงบประมาณ", header: "งบประมาณ" },
	{ value: "budgetType.view", title: "ดูประเภทงบประมาณ", header: "ประเภทงบประมาณ" },  //✅
	{ value: "budgetType.create", title: "สร้างประเภทงบประมาณ", header: "ประเภทงบประมาณ" },
	{ value: "budgetType.update", title: "แก้ไขประเภทงบประมาณ", header: "ประเภทงบประมาณ" },
	{ value: "budgetType.delete", title: "ลบประเภทงบประมาณ", header: "ประเภทงบประมาณ" },
	{ value: "expenseType.view", title: "ดูประเภทค่าใช้จ่าย", header: "ประเภทค่าใช้จ่าย" },  //✅
	{ value: "expenseType.create", title: "สร้างประเภทค่าใช้จ่าย", header: "ประเภทค่าใช้จ่าย" },
	{ value: "expenseType.update", title: "แก้ไขประเภทค่าใช้จ่าย", header: "ประเภทค่าใช้จ่าย" },
	{ value: "expenseType.delete", title: "ลบประเภทค่าใช้จ่าย", header: "ประเภทค่าใช้จ่าย" },
	{ value: "plan.view", title: "ดูแผนงาน", header: "แผนงาน" },  //✅
	{ value: "plan.create", title: "สร้างแผนงาน", header: "แผนงาน" },
	{ value: "plan.update", title: "แก้ไขแผนงาน", header: "แผนงาน" },
	{ value: "plan.delete", title: "ลบแผนงาน", header: "แผนงาน" },
	{ value: "unit.view", title: "ดูหน่วยนับ", header: "หน่วยนับ" },  //✅
	{ value: "unit.create", title: "สร้างหน่วยนับ", header: "หน่วยนับ" },
	{ value: "unit.update", title: "แก้ไขหน่วยนับ", header: "หน่วยนับ" },
	{ value: "unit.delete", title: "ลบหน่วยนับ", header: "หน่วยนับ" },
	{ value: "project.view", title: "ดูโครงการ", header: "โครงการ" },  //✅
	{ value: "project.create", title: "สร้างโครงการ", header: "โครงการ" },
	{ value: "project.update", title: "แก้ไขโครงการ", header: "โครงการ" },
	{ value: "project.publish", title: "อนุมัติและเผยแพร่", header: "โครงการ" },
	{ value: "project.unpublish", title: "ยกเลิกการอนุมัติ", header: "โครงการ" },
	{ value: "project.evaluationSetting", title: "ตั้งค่าประเมินโครงการ", header: "โครงการ" },
	{ value: "project.evaluate", title: "ประเมินโครงการ", header: "โครงการ" },
	{ value: "project.transfer", title: "โอนย้ายงบประมาณ", header: "โครงการ" },
	{ value: "project.delete", title: "ลบโครงการ", header: "โครงการ" },
	{ value: "purchase.view", title: "ดู PR/PO", header: "PR/PO" },
	{ value: "purchase.create", title: "สร้าง PR/PO", header: "PR/PO" },
	{ value: "purchase.delete", title: "ลบ PR/PO", header: "PR/PO" },
	{ value: "section.view", title: "ดูฝ่าย/ส่วนงาน/องค์กร", header: "ฝ่าย/ส่วนงาน/องค์กร" }, //✅
	{ value: "section.create", title: "สร้างฝ่าย/ส่วนงาน/องค์กร", header: "ฝ่าย/ส่วนงาน/องค์กร" },
	{ value: "section.update", title: "แก้ไขฝ่าย/ส่วนงาน/องค์กร", header: "ฝ่าย/ส่วนงาน/องค์กร" },
	{ value: "section.delete", title: "ลบฝ่าย/ส่วนงาน/องค์กร", header: "ฝ่าย/ส่วนงาน/องค์กร" },
	{ value: "event.create", title: "สร้างกิจกรรม", header: "กิจกรรม" },
	{ value: "event.update", title: "แก้ไขกิจกรรม", header: "กิจกรรม" },
	{ value: "event.delete", title: "ลบกิจกรรม", header: "กิจกรรม" },
	{ value: "strategic.view", title: "ดูยุทธศาสตร์", header: "ยุทธศาสตร์" }, //✅
	{ value: "strategic.create", title: "สร้างยุทธศาสตร์", header: "ยุทธศาสตร์" },
	{ value: "strategic.update", title: "แก้ไขยุทธศาสตร์", header: "ยุทธศาสตร์" },
	{ value: "strategic.delete", title: "ลบยุทธศาสตร์", header: "ยุทธศาสตร์" },
	{ value: "report.view", title: "หน้าหลัก(ภาพรวม)", header: "รายงาน" }, //✅
	// { value: "report.export", title: "พิมพ์/นำรายงานออกไปใช้", header: "รายงาน" },
	{ value: "log.projectTransferLogs", title: "ประวัติการโอนงบประมาณ", header: "รายงาน" },
	{ value: "report.expensesReports", title: "รายงานค่าใช้จ่าย", header: "รายงาน" },
	{ value: "report.misReport1", title: "รายงาน MIS รายละเอียดสถานะของการบริหารงบประมาณ", header: "รายงาน" },
	{ value: "report.misReport2", title: "รายงาน MIS ภาพรวมการบริหารงบประมาณ", header: "รายงาน" },
	{ value: "setting.import", title: "นำเข้าข้อมูล", header: "การตั้งค่า" },
	{ value: "setting.export", title: "ส่งออกข้อมูล", header: "การตั้งค่า" },
	{ value: "setting.config", title: "ตั้งค่าระบบ", header: "การตั้งค่า" }, //✅
	{ value: "log.user", title: "ประวัติการใช้งานผู้ใช้", header: "ประวัติการทำงาน" }, //✅
	{ value: "log.sync", title: "ประวัติ PO/PR", header: "ประวัติการทำงาน" }, //✅
]
